export const lang = {
    uz:{
        header:{
            posts:"Postlar",
            users:"Foydalanuvchilar"
        },
        postsPage:{
            posts:"Postlar",
            all:"Barchasi"
        },
        users:{
            addBtn:"Foydalanuvchi qo'shish",
            editBtn:"Tahrirlash"
        },
        userPage:{
            email:"Email",
            name:"Ismi",
            userName:"Foydalanuvchi nomi"
        }
    },
    en:{
        header:{
            posts:"Posts",
            users:"Users"
        },
        postsPage:{
            posts:"Posts",
            all:"All"
        },
        userPage:{
            email:"Email",
            name:"Name",
            userName:"UserName"
        },
        users:{
            addBtn:"Add User",
            editBtn:"Edit"
        },
    }
}